export default "__VITE_ASSET__Bu8xOdRW__"